import { render, staticRenderFns } from "./Ubicaciones.vue?vue&type=template&id=0ce70141&scoped=true&"
import script from "./Ubicaciones.vue?vue&type=script&lang=js&"
export * from "./Ubicaciones.vue?vue&type=script&lang=js&"
import style0 from "./Ubicaciones.vue?vue&type=style&index=0&id=0ce70141&lang=scss&scoped=true&"
import style1 from "./Ubicaciones.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce70141",
  null
  
)

export default component.exports